import type {TuiLanguageEditor} from '@taiga-ui/i18n/types';

export const TUI_ARABIC_LANGUAGE_ADDON_EDITOR: TuiLanguageEditor = {
    colorSelectorModeNames: ['Couleur unie', 'Dégradé de couleur'],
    toolbarTools: {
        undo: 'إلغاء',
        redo: 'إسترجاع',
        font: 'الخط',
        fontStyle: 'نمط الخط',
        fontSize: 'حجم الخط',
        bold: 'غامق',
        italic: 'مائل',
        underline: 'تسطير',
        strikeThrough: 'شطب',
        justify: 'ضبط',
        justifyLeft: 'محاذاة لليسار',
        justifyCenter: 'مركز',
        justifyRight: 'محاذاة لليمين',
        justifyFull: 'ضبط',
        list: 'قائمة',
        indent: 'مسافة بادئة',
        outdent: 'تقليل الانكماش',
        unorderedList: 'قائمة نقطية',
        orderedList: 'قائمة مرقمة',
        quote: 'إقتباس',
        foreColor: 'لون النص',
        backColor: 'لون الخلفية',
        hiliteColor: 'لون تسليط الضوء',
        clear: 'حذف',
        link: 'الرابط',
        attach: 'إرفاق ملف',
        tex: 'إدراج TeX',
        code: 'الكود',
        image: 'إدراج صورة',
        insertHorizontalRule: 'أدخل مسطرة أفقية',
        superscript: 'حرف فوقي',
        subscript: 'حرف منخفض',
        insertTable: 'إدراج جدول',
        insertGroup: 'إدراج مجموعة',
        hiliteGroup: 'Hilite مجموعة',
        removeGroup: 'حذف المجموعة',
        insertAnchor: 'إدراج نقطة ارتكاز',
        mergeCells: 'دمج الخلايا',
        splitCells: 'تقسيم الخلايا',
        rowsColumnsManaging: 'إدارة الصفوف والأعمدة',
        cellColor: 'لون الخلية',
        setDetails: 'مجموعة التفاصيل',
        removeDetails: "حذف مجموعة التفاصيل",
    },
    editorEditLink: {
        urlExample: 'exemple.com',
        anchorExample: 'مثبت',
    },
    editorTableCommands: [
        ['إدراج عمود أمامي', 'إدراج عمود بعد'],
        ['إدراج سطر قبل', 'إدراج سطر بعد'],
        ['حذف العمود', 'احذف السطر'],
    ],
    editorCodeOptions: ['الرمز في النص', 'مجموعة الرموز'],
    editorFontOptions: {
        small: 'صغير',
        large: 'كبير',
        normal: 'عادي',
        title: 'عنوان',
        subtitle: 'عنوان فرعي',
    },
};
